import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as favoritesTabActions from "../../../../actions/favoritesTabActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as modelHelper from "../../../../helpers/modelHelper";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";
import Modal from "../../../global/generic/Modal";
import Button from "../../../global/generic/Button";
import CancelButton from "../../../global/generic/CancelButton";
import Input from "../../../global/generic/Input";

class DeleteFavoriteFolderModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            removeContent: false
        };
    }

    handleDeleteRadioButtonChange = (event) => {
        if (event.target.value === "Delete") {
            this.setState({
                removeContent: true
            });
        }
        if (event.target.value === "MoveTo") {
            this.setState({
                removeContent: false
            });
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
    };

    handleDeleteFolderClick = () => {
        this.props.dispatchDeleteFolderAction(this.props.tabId, this.props.params.folderId, this.state.removeContent);
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="col-12 std-border-bottom padding-bottom-10 margin-bottom-10">
                    <Translate value="favoritesTab.message.wantToDeleteFolder" />
                </div>
                <div className="col-12">
                    <Translate value="favoritesTab.message.formulasFromFolder" />:
                </div>
                <div className="col-12">
                    <label className="font-normal" style={{cursor: "pointer"}}>
                        <Input
                            type="radio"
                            value="Delete"
                            checked={this.state.removeContent}
                            onChange={this.handleDeleteRadioButtonChange}
                            labelAfter={<Translate value="favoritesTab.message.removeAllFormulas" />}
                        />
                    </label>
                </div>
                <div className="col-12">
                    <label className="font-normal" style={{cursor: "pointer"}}>
                        <Input
                            type="radio"
                            value="MoveTo"
                            checked={!this.state.removeContent}
                            onChange={this.handleDeleteRadioButtonChange}
                            labelAfter={<Translate value="favoritesTab.message.moveAllFormulas" />}
                        />
                    </label>
                </div>
            </React.Fragment>,
            "col-12 flex flex-wrap line-height-3_7vh"
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <Button
                    label={translate("general.confirm")}
                    onClick={this.handleDeleteFolderClick}
                    svgBefore={imgConfirm}
                />
                <CancelButton onClick={this.handleCloseModalClick} />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.tabId}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="favoritesTab.deleteFolder" />)}
                content={this.getContent()}
                footer={this.getFooter()}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchDeleteFolderAction: (tabId, folderId, removeContent) => {
            dispatch(favoritesTabActions.deleteFolder(tabId, folderId, removeContent));
        },
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.DELETE_FAVORITE_FOLDER_MODAL));
        }
    };
};

export default DeleteFavoriteFolderModal = connect(mapStoreToProps, mapDispatchToProps)(DeleteFavoriteFolderModal);
